import client from 'http/client';

/**
 * Does a config request on the API.
 *
 * @returns {Promise}
 */
export const configRequest = () => {
    return client.get('/config');
};



// WEBPACK FOOTER //
// ./src/http/requests/configRequests.js